/* tslint:disable */
/* eslint-disable */
export enum RoofProducerEnum {
  Bilka = 'Bilka',
  Wetterbest = 'Wetterbest',
}
